if (!customElements.get('accordion-component')) {
  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.accordion = this;
      this.accordionBtn = this.querySelector('.js-accordion-button');
      this.accordionContent = this.querySelector('.js-accordion-content');

      this.accordionBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.accordion.classList.contains('is-open')) {
          this.close();
        }
        else {
          this.open();
        }
      })
    }
    close() {
      this.accordionContent.style.height = null;
      this.accordion.classList.remove('is-open');
      this.accordionContent.classList.remove('is-open');
    }
    open() {
      this.closest('.js-accordions-container')?.querySelectorAll('accordion-component')?.forEach(accordion => accordion.close());
      this.accordionContent.style.height = this.accordionContent.scrollHeight + 'px';
      this.accordionContent.classList.add('is-open');
      this.accordion.classList.add('is-open');
    }
  }
  customElements.define('accordion-component', AccordionComponent);
}